import { ZenToast } from "zen-core-elements";
import { TaxReportResponse, PayloadProps } from "../../components/dashboard/taxReport/taxReport.module";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";


interface initialData {
    taxReportData: { value: TaxReportResponse | null, loading: boolean, error: string, isReached: boolean, filter: string | null },
}

const initialState: initialData = {
    taxReportData: { value: null, error: "", loading: true, isReached: false, filter: null },

}

interface payloadProps {
    data: PayloadProps | undefined
}
//to fetch all tax report data
export const getAllTaxReport = createAsyncThunk("report/getAllTaxReport", ({ data }: payloadProps) => {
    const url = HttpRoutingService.replaceUrl("stores/{storeId}/pos/report/tax", { storeId: data?.storeId })
    return HttpRoutingService.getMethod<TaxReportResponse>(url, data,)
})


export const TaxReportSlice = createSlice({
    name: 'taxReport',
    initialState: initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder.addCase(getAllTaxReport?.pending, (state) => {
            state.taxReportData.loading = true
        })
            .addCase(getAllTaxReport.fulfilled, (state, action) => {
                state.taxReportData.loading = false
                let prev = state.taxReportData.value;
                let current = action.payload;
                let combine: TaxReportResponse | null = null
                let offset = action.meta.arg?.data?.offset!
                if (offset > 0) {
                    combine = {
                        message: current?.message ?? prev?.message ?? "",
                        statusCode: current?.statusCode ?? prev?.statusCode ?? "",
                        success: current?.success ?? prev?.success ?? false,
                        taxReport: {
                            overallSummary: {
                                ...prev?.taxReport?.overallSummary,
                                ...current?.taxReport?.overallSummary,
                            },
                            taxSummary: [
                                ...(prev?.taxReport?.taxSummary || []),
                                ...(current?.taxReport?.taxSummary || []),
                            ],
                            taxSummaryCount: current?.taxReport?.taxSummaryCount || 0
                        },
                    };
                }
                if (current?.taxReport?.taxSummary?.length < action.meta.arg.data?.limit!) {
                    state.taxReportData.isReached = true
                }
                else {
                    state.taxReportData.isReached = false
                }
                state.taxReportData.value = offset > 0 ? combine : action.payload
                state.taxReportData.filter = action.meta.arg.data?.filterData!
            })
        builder.addCase(getAllTaxReport?.rejected, (state, action) => {
            state.taxReportData.loading = false
            state.taxReportData.error = action?.error?.message ? action?.error?.message : 'Error in getAllTaxReport'
            ZenToast({ type: "error", message: action?.error?.message ? action?.error?.message : 'Error in getAllTaxReport' })
        })


    }
})

export default TaxReportSlice?.reducer
